export default __webpack_public_path__ + "/dist/images/copy-link.svg";